import { ErrorParagraph, FieldWrapper, Input, Title } from "./styles";
import { SimpleFormField } from "../../../../global/types";

type FormField = {
  contractField: SimpleFormField;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
};

export default function FormField({
  contractField: { label, error, value },
  onBlur,
  onChange,
}: FormField) {
  return (
    <FieldWrapper>
      <Title>{label.toUpperCase()}</Title>
      <Input onChange={onChange} value={value} onBlur={onBlur} />
      {error ? <ErrorParagraph>{error}</ErrorParagraph> : null}
    </FieldWrapper>
  );
}
